import {Button, DatePicker, Form, Row, Space, Spin} from "antd";
import {exportFile, formatDateToString} from "helper/common";
import React, {useState} from "react";
import dayjs from "dayjs";
const KhamMat = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const exportReport = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const year = dayjs(form.getFieldValue("year")?.toString()).year();
      await exportFile(
        "qlkhambenh/bao-cao-tong-hop/bao-cao-kham-mat",
        {year: year},
        `Báo cáo khám mắt năm ${year}`
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Spin spinning={loading}>
      <div className="container page">
        <Form form={form}>
          <Space>
            <Form.Item
              name="year"
              rules={[{required: true, message: "Chưa chọn năm"}]}
            >
              <DatePicker picker="year"></DatePicker>
            </Form.Item>
            <Button type="primary" onClick={exportReport}>
              Xuất báo cáo
            </Button>
          </Space>
        </Form>
      </div>
    </Spin>
  );
};
export default KhamMat;
